import styled from "styled-components";

export const WrapperContainerAdmin = styled.div`
    max-width: 80%;
    width: 100%;
    margin: 0 auto;
    padding: 35px;
    margin-left: 350px;
`